export const MAX_BYTES = 4096
export const MAX_LIST = 50
export const MAX_DISPLAY_METRICS = 15
export const MAX_METADATA = 20
export const MAX_EXCLUDED_METADATA_VALUES = 50
export const MAX_TAGS = 20

export const ID_LISTS = new Set([
  "agent_ids",
  "agent_version_ids",
  "test_set_ids",
  "test_set_version_ids",
  "test_case_ids",
  "persona_ids",
  "persona_version_ids",
  "run_ids",
  "simulation_output_ids",
])

export const REVIEWER_LISTS = new Set([
  "reviewer_ids",
  "assigned_to",
  "labeled_by",
  "triaged_by",
])

export const STRING_LISTS = new Set(["triage_values", "run_tags"])

export const FILTER_FIELDS = new Set([
  "source",
  "created_at_start",
  "created_at_end",
  "occurred_at_start",
  "occurred_at_end",
  "conversation_review_progress",
  "reviewer_ids",
  "reviewer_progress",
  "suspect_label_families",
  "assigned_to",
  "assignment_status",
  "labeled_by",
  "label_state",
  "label_updated_at_start",
  "label_updated_at_end",
  "triage_state",
  "triage_values",
  "triaged_by",
  ...ID_LISTS,
  "simulation_output_id_prefix",
  "customer_metadata",
  "excluded_customer_metadata",
  "run_tags",
  "focus",
])

export const FOCUS_FIELDS = new Set([
  "metric_id",
  "answer_state",
  "human_value",
  "machine_value",
  "machine_metric_version_ids",
  "agreement_state",
  "selected_comparison",
])
